
























import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { NavigationItem } from "@/model/NavigationItem";
import { NAVIGATION_STATUS } from "@/model/NavigationStatus";
import { IppanSeibiService } from "@/service/IppanSeibiService";

@Component
export default class Navigation extends Vue {
  @Prop() active: number;
  @Prop() title: string;
  @Prop() navItems: NavigationItem[];
  @Prop() canjump: boolean;
  activePage: number = 0;
  lockNav: boolean = false;
  isUserMode: boolean = true;
  ippanSeibiService: IppanSeibiService;

  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;

  created() {
    this.ippanSeibiService = new IppanSeibiService();
    this.activePage = this.active;
    this.isUserMode = this.$route.meta == "user";
  }

  onChangePage(index: number) {
    if (this.canjump) {
      this.activePage = index;
      this.$emit("changePage", index);
    }
  }
  isActive(status: string) {
    return status === NAVIGATION_STATUS.ACTIVE;
  }
  isRegister(status: string) {
    return status === NAVIGATION_STATUS.REGISTER;
  }
  isRegisterNotComplete(status: string) {
    return status === NAVIGATION_STATUS.REGISTER_NOTCOMPLETE;
  }

  checkLockNavigation() {
    if (this.navItems[0].status != NAVIGATION_STATUS.REGISTER) {
      this.lockNav = true;
    } else {
      this.lockNav = false;
    }
  }

  getClass(item: NavigationItem) {
    const classes: string[] = [];
    if (this.isNextageCustom && (item.page === 'partsselect' || item.page === 'workorder')) {
      // ネクステージの場合は「作業/部品選択」と「整備完了報告」を非活性にする
      classes.push('no-click invalid');
    } else if (this.ippanSeibiService.isIppanSeibi && (item.page === 'currentcarcheck' || item.page === 'legal56')) {
      // 一般整備の場合は「現車確認」と「57項目点検」を非活性にする
      classes.push('no-click invalid');
    } else {
      if (this.lockNav) {
        classes.push('no-click');
      } else if (this.canjump) {
        classes.push('pointer');
      }
      if (this.isActive(item.status)) {
        classes.push('active');
      } else if (this.isRegister(item.status)) {
        classes.push('register');
      } else if (this.isRegisterNotComplete(item.status)) {
        classes.push('register-not-complete');
      }
    }
    return classes;
  }
}
